var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

module.exports =
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee(x0, y0, x1, y1) {
  var dx, dy, adx, ady, eps, sx, sy, x, y;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          dx = x1 - x0;
          dy = y1 - y0;
          adx = Math.abs(dx);
          ady = Math.abs(dy);
          eps = 0;
          sx = dx > 0 ? 1 : -1;
          sy = dy > 0 ? 1 : -1;

          if (!(adx > ady)) {
            _context.next = 19;
            break;
          }

          x = x0, y = y0;

        case 9:
          if (!(sx < 0 ? x >= x1 : x <= x1)) {
            _context.next = 17;
            break;
          }

          _context.next = 12;
          return {
            x: x,
            y: y
          };

        case 12:
          eps += ady;

          if (eps << 1 >= adx) {
            y += sy;
            eps -= adx;
          }

        case 14:
          x += sx;
          _context.next = 9;
          break;

        case 17:
          _context.next = 28;
          break;

        case 19:
          x = x0, y = y0;

        case 20:
          if (!(sy < 0 ? y >= y1 : y <= y1)) {
            _context.next = 28;
            break;
          }

          _context.next = 23;
          return {
            x: x,
            y: y
          };

        case 23:
          eps += adx;

          if (eps << 1 >= ady) {
            x += sx;
            eps -= ady;
          }

        case 25:
          y += sy;
          _context.next = 20;
          break;

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
});